export const OTHERS_MATERIAL_ID = '__others__';

export interface MaterialTotal {
  materialId: string;
  units: number;
}

export interface TopMaterial extends MaterialTotal {
  /** Vacío en el bucket "Otros": la etiqueta la pone la vista (i18n). */
  name: string;
}

/**
 * Los `n` materiales con más unidades y, si sobran, un bucket `__others__` con
 * la suma del resto. Los materiales en cero no se muestran.
 */
export const topMaterials = (
  totals: MaterialTotal[],
  catalog: { materialId: string; name: string }[],
  n = 5
): TopMaterial[] => {
  const names = new Map(catalog.map((m) => [m.materialId, m.name]));
  const sorted = totals
    .filter((t) => t.units > 0)
    .map((t) => ({
      materialId: t.materialId,
      name: names.get(t.materialId) ?? t.materialId,
      units: t.units,
    }))
    .sort((a, b) => b.units - a.units || a.name.localeCompare(b.name));

  const top = sorted.slice(0, n);
  const rest = sorted.slice(n);

  if (rest.length === 0) return top;

  return [
    ...top,
    {
      materialId: OTHERS_MATERIAL_ID,
      name: '',
      units: rest.reduce((sum, m) => sum + m.units, 0),
    },
  ];
};
